module.exports = __webpack_public_path__ + "img/vase-bumper.9b3ff681.png";